import { render, staticRenderFns } from "./ChenosisLoginModal.vue?vue&type=template&id=4b3ebff6&"
import script from "./ChenosisLoginModal.vue?vue&type=script&lang=js&"
export * from "./ChenosisLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports